import { useInterval } from "usehooks-ts";
import { useState } from "react";

export const WEATHER_TILES_REFRESH_INTERVAL_MS = 2 * 60 * 1000;

export function getWeatherTilesUrl(params: {
  weatherLayer: string;
  weatherDateTime: string;
  weatherAltitude: string;
  sessionToken: string;
}) {
  // http://tiber.meandair.com/api/v1/tiles/{weatherLayer}/{z}_{weatherAltitude}_{x}_{y}_{weatherDateTime}.png?session={sessionToken}
  const url = Object.entries(params ?? {}).reduce((acc, entry) => {
    if (entry[1] != null) {
      const regexp = new RegExp("\\{" + entry[0] + "\\}", "g");
      return acc?.replace(regexp, entry[1]);
    }

    return acc;
  }, process.env.REACT_APP_WEATHER_TILES_URI);

  return url;
}

export function useWeatherTilesRefreshKey() {
  const [refreshKey, setRefreshKey] = useState(() => Date.now());

  useInterval(() => {
    setRefreshKey(Date.now());
  }, WEATHER_TILES_REFRESH_INTERVAL_MS);

  return refreshKey;
}
